"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLayoutRenderer = DefaultLayoutRenderer;
const react_1 = __importDefault(require("react"));
function DefaultLayoutRenderer({ selectors, translateGroupName, closedGroups, onToggleGroupClosed, GroupComponent, GroupItemComponent, PropertySelectorComponent, PropertyLabelComponent }) {
    const groups = getDistinctGroupNames(selectors);
    return (react_1.default.createElement("div", null, groups.map(groupName => {
        const isClosedGroup = closedGroups.indexOf(groupName) !== -1;
        const renderedSelectorsForGroup = selectors.filter(selector => selector.groupName === (groupName || ""));
        return (react_1.default.createElement(GroupComponent, { key: groupName, isClosedGroup: isClosedGroup, groupName: groupName, onToggleGroupClosed: onToggleGroupClosed, translateGroupName: translateGroupName }, renderedSelectorsForGroup.map(selector => (react_1.default.createElement(GroupItemComponent, { key: selector.propertyName, selector: selector, PropertySelectorComponent: PropertySelectorComponent, PropertyLabelComponent: PropertyLabelComponent })))));
    })));
}
function getDistinctGroupNames(productPropertiesArray) {
    const groupNames = [];
    for (const property of productPropertiesArray) {
        // let groupName = property.groupName;
        if (isNullOrWhiteSpace(property.groupName)) {
            // groupName = "";
        }
        if (groupNames.indexOf(property.groupName) === -1) {
            groupNames.push(property.groupName);
        }
    }
    return groupNames;
}
function isNullOrWhiteSpace(str) {
    return (str === null ||
        str === undefined ||
        str.length < 1 ||
        str.replace(/\s/g, "").length < 1);
}
//# sourceMappingURL=default-layout-renderer.js.map